import Model from '../../ModelBinding/Model';
import PermissionCollection from '../Permission/PermissionCollection';
import RoleCollection from './RoleCollection';
import dayjs from 'dayjs';
import Organization from '../Organization/Organization';

export default class Role extends Model {
  static rootUri = 'acls/roles';

  public name?: string;
  public locked?: boolean;
  public organization?: Organization;
  public created_at?: dayjs.Dayjs;
  public updated_at?: dayjs.Dayjs;
  public permissions?: PermissionCollection;

  bind() {
    this.name = this.getStringAttribute('name');
    this.locked = this.getBooleanAttribute('locked');
    this.created_at = this.getDateAttribute('created_at');
    this.updated_at = this.getDateAttribute('updated_at');
    this.permissions = this.getRelationCollection('permissions', PermissionCollection) as PermissionCollection;
    this.organization = this.getRelation('organization', Organization) as Organization;
  }

  static getCollection() {
    return RoleCollection;
  }
}
